import cities from "./cities.data";

export { cities };